<!--
  Created 30.10.2023
  Settings slide-over component with button for proposal show page.
-->
<template>
  <div>
    <div
      class="fixed right-0 top-48 z-50 flex"
      :style="'top:' + (8+(4*order)) + 'rem'">
      <button
        type="button"
        class="flex h-12 w-12 items-center justify-center rounded-bl-lg border border-r-0 bg-amber-50 opacity-50
        shadow transition-opacity delay-500 duration-500 ease-in-out hover:cursor-pointer hover:opacity-100 hover:transition-none md:rounded-tl-lg"
        :title="buttonTitle ?? 'Click to open panel'"
        :class="{'!opacity-0 !delay-0 !duration-200':slideOpen}"
        @click="$emit('update:slideOpen', !slideOpen);">
        <component
          :is="icon"
          class="h-7 w-7 text-gray-800" />
      </button>
    </div>
    <SimpleSlideOver
      :slide-open="slideOpen"
      :is-wide="isWide"
      @update:slide-open="(e) => slideOpen = e">
      <template #title>
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          <slot name="title" />
        </h3>
      </template>
      <template #content>
        <slot name="content" />
      </template>
    </SimpleSlideOver>
  </div>
</template>
<script setup>
/* external */
import {
  computed,
  ref, watch,
} from 'vue';
/* local */
import SimpleSlideOver from '@/Components/Slideovers/SimpleSlideOver.vue';
import { Cog8ToothIcon } from '@heroicons/vue/24/outline';

const emit = defineEmits(['update:slideOpen']);

const props = defineProps({
  icon: {
    type: [Object, Function],
    default: Cog8ToothIcon,
  },
  isWide: {
    type: Boolean,
    required: false,
    default: false,
  },
  order: {
    type: Number,
    required: false,
    default: 1,
  },
  buttonTitle: {
    type: String,
    required: false,
    default: null,
  },
  slideOpen: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const slideOpen = computed({
  get() {
    return props.slideOpen;
  },
  set(value) {
    emit('update:slideOpen', value);
  },
});

</script>
